import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import PaginationAdvanced from "../components/PaginationAdvanced";
import { CSSTransitionGroup } from 'react-transition-group';
import Search from "./Search";
import { toastr } from "react-redux-toastr";
import Joyride from "react-joyride";
import moment from "moment";
import * as Constants from '../constants';

import Index from "./Index";
import { fetchCampaignSubscriptions, reengageLead, restartSubscription } from "../actions/index";
import SubscriptionsIndexTourSteps from "./tours/SubscriptionsIndexTourSteps";

export class SubscriptionsIndex extends Index {
  static propTypes = {
    match: PropTypes.object.isRequired,
    fetchCampaignSubscriptions: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    subscriptions: PropTypes.object,
    reengageLead: PropTypes.func.isRequired,
    restartSubscription: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
  }

  fetchData() {
    let newQueries = {
        page: this.state.page || 1,
        per_page: this.state.per_page || "",
        search: this.state.search || "",
        category: this.state.category || "",
        sort: this.state.sort || "",
        direction: this.state.direction || ""
      };
    this.props.fetchCampaignSubscriptions(
      this.props.match.params.id,
      this.serialize(newQueries)
    );
    this.props.history.push(`/campaigns/${this.props.match.params.id}/subscriptions${this.serialize(newQueries)}`);
  }

  startTour() {
    this.setState({
      steps: SubscriptionsIndexTourSteps.tourSteps(),
      startTour: true
    });
  }

  onReengageLeadClick(e) {
    let lead_id = e.target.dataset.leadId;
    this.props
      .reengageLead(lead_id)
      .then(response => {
        if (response.payload.status == 200) {
          this.fetchData();
          toastr.success(
            "Lead reset. Any subscriptions on hiatus will now continue."
          );
        }
      });
  }

  onRestartSubscriptionClick(e) {
    let lead_id = e.target.dataset.leadId;
    let campaign_id = e.target.dataset.campaignId;
    this.props
      .restartSubscription(
        lead_id,
        campaign_id
      )
      .then(response => {
        if (response.payload.status == 200) {
          this.fetchData();
          toastr.success("Subscription resumed.");
        }
      });
  }

  renderSubscriptions() {
    if (!this.props.subscriptions.data) {
      return (
        <tr>
          <td colSpan={9}>
            <div className="vertical-center">
              <CSSTransitionGroup
                transitionName="spinner"
                transitionAppear={true}
                transitionAppearTimeout={500}
              >
                <i className="fa fa-refresh fa-4x fa-spin" />
              </CSSTransitionGroup>
            </div>
          </td>
        </tr>
      );
    } else if (this.props.subscriptions.data.length == 0) {
      return (
        <tr>
          <td colSpan={9}>
            <div className="well well-lg text-center">
              You have no subscriptions.
            </div>
          </td>
        </tr>
      );
    }

    return this.props.subscriptions.data.map(subscription => {
      if (subscription.recipient != undefined) {
        return (
          <tr key={subscription.id}>
            <td>{subscription.recipient.first_name}</td>
            <td>{subscription.recipient.last_name}</td>
            <td>{subscription.recipient.email}</td>
            <td>{subscription.recipient.phone}</td>
            <td>{this.renderStatus(subscription)}</td>
            <td>{this.renderVersion(subscription)}</td>
            <td>{this.renderStep(subscription)}</td>
            <td>
              <Link
                to={`/campaigns/${
                  subscription.campaign_id
                }/emails?search=${
                  subscription.recipient.email
                }&direction=&page=1&per_page=&sort=`}
                className="btn btn-sm btn-default subscription_emails m-l-5"
              >
                Emails
              </Link>
            </td>
            <td>
              <Link
                to={`/campaigns/${
                  subscription.campaign_id
                }/sms?search=${
                  subscription.recipient.phone
                }&direction=&page=1&per_page=&sort=`}
                className="btn btn-sm btn-default subscription_sms m-l-5"
              >
                SMS
              </Link>
            </td>
            <td>
              <Link
                to={`/campaigns/${
                  subscription.campaign_id
                }/rvms?${Constants.DEFAULT_PAGINATION}`}
                className={`btn btn-sm btn-default subscrition_rvms m-l-5 ${
                  Constants.BETA_SITE_UUIDS.includes(localStorage.getItem('lastSiteUUID')) ? "show" : "hide"
                }`}
              >
                VMs
              </Link>
            </td>
          </tr>
        );
      }
    });
  }

  renderStep(subscription) {
    if (subscription.last_performed_step) {
      return (
        <td>
          <Link
            to={`/campaigns/${subscription.campaign_version.campaign_id}/versions/${subscription.campaign_version_id}`}
            className="btn btn-sm btn-default"
          >
            {subscription.last_performed_step}
          </Link>
        </td>
      );
    }
  }

  renderVersion(subscription) {
    return (
      <td>
        <Link
          to={`/campaigns/${subscription.campaign_version.campaign_id}/versions/${subscription.campaign_version_id}`}
          className="btn btn-sm btn-default"
        >
          {subscription.campaign_version.number}: {moment(subscription.campaign_version.created_at).format("MM/DD/YYYY")}
        </Link>
      </td>
    );
  }

  renderStatus(subscription) {
    let current_hiatus = subscription.current_hiatus;
    let lead_external_id = subscription.recipient.external_id;
    if (current_hiatus != null) {
      if (
        current_hiatus.reason != null &&
        current_hiatus.reason != "Outside Office Hours"
      ) {
        if (
          current_hiatus.reason == "bad email" ||
          current_hiatus.reason.substring(0, 9) == "Unengaged"
        ) {
          return (
            <span className={`label label-warning text-capitalize`}>
              {current_hiatus.reason}
              <a
                className="m-l-5"
                style={{ cursor: "pointer" }}
                data-lead-id={lead_external_id}
                onClick={this.onReengageLeadClick.bind(this)}
              >
                Retry
              </a>
            </span>
          );
        } else if (
          current_hiatus.reason == "Subscription paused due to agent communication" ||
          current_hiatus.reason == "waiting on manual step"
        ) {
          return (
            <span className={`label label-warning text-capitalize`}>
              {current_hiatus.reason}
              <a
                className="m-l-5"
                style={{ cursor: "pointer" }}
                data-lead-id={lead_external_id}
                data-campaign-id={subscription.campaign_id}
                onClick={this.onRestartSubscriptionClick.bind(this)}
              >
                Resume
              </a>
            </span>
          );
        } else {
          return (
            <span className={`label label-warning text-capitalize`}>
              {current_hiatus.reason}
            </span>
          );
        }
      } else if ( current_hiatus.reason == "Outside Office Hours") {
        return (
          <span className={`label label-warning text-capitalize`}>Outside Office Hours</span>
        );
      } else {
        return (
          <span className={`label label-warning text-capitalize`}>Unknown</span>
        );
      }
    } else {
      return <span className={`label label-success`}>Active</span>;
    }
  }

  render() {
    let count = 0;
    if (!this.props.subscriptions.meta) {
      return (
        <div className="vertical-center">
          <CSSTransitionGroup
            transitionName="spinner"
            transitionAppear={true}
            transitionAppearTimeout={500}
          >
            <i className="fa fa-refresh fa-4x fa-spin" />
          </CSSTransitionGroup>
        </div>
      );
    }
    count = this.props.subscriptions.meta.count;
    return (
      <div className="subscriptions_index">
        <Joyride
          run={this.state.startTour}
          continuous={true}
          steps={this.state.steps}
          showSkipButton={true}
          showProgress={true}
          scrollToSteps={false}
          callback={this.tourCallback.bind(this)}
        />
        <div className="row">
          <h1>
            <span className="campaign_name">
              {this.props.subscriptions.meta.campaign_name} Subscriptions
              <button
                bsStyle="default"
                className="btn btn-sm btn-primary help_icon_smaller"
                onClick={this.startTour.bind(this)}
              >
                ?
              </button>
            </span>
            <div className="pull-right">
              <Search
                handleSearch={this.handleSearch.bind(this)}
                searchStr={this.state.search}
              />
            </div>
            <a
              href={`https://leads.realgeeks.com/leads`}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary pull-right add_lead_btn m-r-10"
            >
              Add Leads from Lead Manager
            </a>
          </h1>
          <table className="table table-striped">
            <thead>
              <tr>
                <th className="subscription_first_name">First Name</th>
                <th className="subscription_last_name">Last Name</th>
                <th className="subscription_email">Email</th>
                <th className="subscription_phone">Phone</th>
                <th className="subscription_status">Status</th>
                <th className="subscription_version">Version</th>
                <th className="subscription_last_performed_step">Last Step Performed</th>
                <th />
              </tr>
            </thead>
            <tbody>{this.renderSubscriptions()}</tbody>
          </table>
        </div>
        <div className="row text-right">
          <PaginationAdvanced
            handle={this.handlePagination.bind(this)}
            total={count}
            page={this.state.page}
            per_page={this.state.per_page}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { subscriptions: state.campaigns.subscriptions };
}

export default connect(
  mapStateToProps,
  { fetchCampaignSubscriptions, reengageLead, restartSubscription }
)(SubscriptionsIndex);
